<template>
    <sa-page-layout :btnConfigurazioniVisible="true" :btnRefreshVisible="true" :btnNewVisible="false"
        :linkConfigurazioni="linkConfigurazione" @refresh="onRefresh">
        <template #toolbar>
            <b-button class="button-new" size="sm" variant="success btn-toolbar float-sm-right sa-margin-right"
                @click="onNew">
                <b-icon icon="plus"></b-icon>
                {{ $t("global.lblBtnNew") }}
            </b-button>
        </template>
        <template #table-filter>
            <div class="sa-list-component-header" style="padding: 5px">
                <div class="sa-page-search-component">
                    <b-form style="width: 100%" @submit.prevent="onSubmit">

                    </b-form>
                </div>
            </div>
        </template>
        <template slot="table-body">
            <AgendaAppuntamentiStatiListComponent ref="cmpAgendaAppuntamentiStatiList" />
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from '../../../../template/sa/components/layout/contents/SaPageLayout.vue';
import AgendaAppuntamentiStatiListComponent from '../components/AgendaAppuntamentiStatiListComponent.vue';
import UtilityMixin from '../../../utility/UtilityMixin.js';
import toast from '../../../../template/layout/utility/sa-toast.js';
export default {
    mixins: [UtilityMixin],
    components: { SaPageLayout, AgendaAppuntamentiStatiListComponent },
    inject: ["openShowModalLoading", "closeShowModalLoading"],

    data() {
        return {
            linkConfigurazione: "/configurazioneagende",
            pathResource: "/agendaappuntamentipagamentistati",
            filtroSessionStorage: "filtroConfigurazioneAgendaPagamenti",
            showModalLoading: false,
            presidio: {},
            filtroTipologieVisite: {},
            struttureOptions: [],

        };
    },
    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        this.getPresidio();
        me.showModalLoading = true;
        let filtroTipologieVisite = sessionStorage.getItem(this.filtroSessionStorage);
        if (filtroTipologieVisite) {
            me.filtroTipologieVisite = JSON.parse(filtroTipologieVisite);
        }
        //me.filtroTipologieVisite.codiceStruttura = this.presidio.codiceStruttura;
        me.loadData(me.filtroTipologieVisite);
    },
    methods: {
        loadData(filtro) {
            let me = this;
            me.$refs.cmpAgendaAppuntamentiStatiList.loadData(filtro);
        },
        onRefresh() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            me.showModalLoading = true;
            let filtroTipologieVisite = sessionStorage.getItem(this.filtroSessionStorage);
            if (filtroTipologieVisite) {
                me.filtroTipologieVisite = JSON.parse(filtroTipologieVisite);
            }
            me.loadData(me.filtroTipologieVisite);
        },
        getPresidio() {
            let tmpPresidio = window.localStorage.getItem("presidio");
            if (tmpPresidio) {
                this.presidio = JSON.parse(tmpPresidio);
            }
        },
        resetFiltriConfigurazioneDevice() {
            let me = this;
            me.filtroTipologieVisite = {
                codiceStruttura: this.presidio.codiceStruttura
            };
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem(this.filtroSessionStorage, JSON.stringify(this.filtroTipologieVisite));
            this.$refs.cmpAgendaAppuntamentiStatiList.loadData();
        },
        onNew() {
            this.$refs.cmpAgendaAppuntamentiStatiList.onEdit({ id: "-1", imeii: "", sistemaOperativo: "", tipo: "", statoAttuale: "", password: "" });
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            console.log(this.presidio);

            me.filtroTipologieVisite.codiceStruttura = this.presidio.codiceStruttura;
            sessionStorage.setItem(this.filtroSessionStorage, JSON.stringify(me.filtroTipologieVisite));

            me.$refs.cmpAgendaAppuntamentiStatiList.loadData(me.filtroTipologieVisite);
        },
        loadDataUtentiPresidio() {
            let me = this;
            let utente = JSON.parse(sessionStorage.getItem("user"));
            UtilityMixin.methods.loadDataResources("/utentipresidi", { idUtente: utente.id }, me.loadDataUtentiPresidiSuccess, me.loadDataUtentiPresidiError);
        },
        loadDataUtentiPresidiSuccess(response) {
            this.struttureOptions = response.data.data.list;
        },
        loadDataUtentiPresidiError(error) {
            console.log(error);
            toast.error("errore durante il caricamento dei presidi dell'utente")
        },
    },
};
</script>
<style scoped>
.button-new {
    border: 1px solid #218838;
}
</style>
